module.exports = __webpack_public_path__ + "static/media/location-new-york.3bd6b154.jpg";